(function() {

    'use strict';



    // internal constants
    var cors = SAPO.Utility.cors, // cors ajaxCORS flashCORS
        XML2 = SAPO.Utility.XML2;

    var CORS_TIMEOUT = 10;



    var clone = function(o) {
        return JSON.parse( JSON.stringify(o) );
    };

    var pushIfLacking = function(arr, el) {
        for (var i = 0, f = arr.length; i < f; ++i) {
            if (arr[i] === el) { return; }
        }
        arr.push(el);
    };

    var toArray = function(els) {
        var l = els.length;
        var arr = new Array(l); // optimizable *list-to-array
        for (var i = 0; i < l; ++i) {
            arr[i] = els[i];
        }
        return arr;
    };

    var getAncestor = function(el, ancestorName) {
        ancestorName = ancestorName.toLowerCase();
        do {
            if (el.nodeName.toLowerCase() === ancestorName) {
                return el;
            }
            el = el.parentNode;
        } while (el);
    };

    /*var genId = function(prefix) {
        return prefix + ( ~~(Math.random() * Math.pow(32, 6)) ).toString(32);
    };

    var getKeys = function(o) {
        var keys = [];
        for (var k in o) {
            if (o.hasOwnProperty(k)) {
                keys.push(k);
            }
        }
        return keys;
    };*/



    /**
     * vp = new VASTParser();
     *
     * vp.on(eventType, cb) (..)
     * loadDocument document error done
     *
     * vp.getDocument(vastXMLUrl);
     */
    var VASTParser = function() {
        this._listeners = {};    // START OF EVENT EMITTER ATTRIBUTES
        this._maxListeners = 10; // END   OF EVENT EMITTER ATTRIBUTES

        //this._data;
        this._running = false;
        this._sourceFilesRemaining = 0;
    };

    VASTParser.prototype = {

        reset: function() {
            this._running = true;
            this._sourceFilesRemaining = 0;

            this._data = {
                sourceUrls: [], // URLs where the VAST files came from

                ads: {}, // one per ad id, having impression and error arrays. there's also a special key '*' for wrappers
                //titles: [],

                // the folloing are volatile, deleted after wrapper resolution
                globalTracking: {
                    linears:    {},
                    nonLinears: {},
                    companions: {}
                },
                globalVideoClicks: {} // only linears!
            };
        },

        getDocument: function(xmlVastDocUrl, isInternal) {
            if (this._running && !isInternal) {
                return this.emit('error', 'was already running!');
            }

            if (!isInternal) {
                this.reset();
            }

            this.emit('getDocument', xmlVastDocUrl);

            this._data.sourceUrls.push(xmlVastDocUrl);
            ++this._sourceFilesRemaining;

            cors(
                xmlVastDocUrl,
                this.parseDocument.bindObj(this),
                this.getFailed.bindObj(this, xmlVastDocUrl),
                CORS_TIMEOUT,
                true
            );
        },

        parseDocument: function(tmp, doc) {
            this.emit('document', doc);

            --this._sourceFilesRemaining;

            try {
                this.parseVAST( XML2.getChildren(doc, 'VAST')[0] );
            } catch (ex) {
                //console.log(ex); // TODO DEBUG
                this.emit('error', {code:100, message:'XML parsing error: processing VAST element'});
            }

            if (this._sourceFilesRemaining === 0) {

                delete this._data.globalTracking;
                delete this._data.globalVideoClicks;

                this.emit('done', this._data);

                this._running = false;
                this._data = {sourceUrls:[]};
            }
        },

        parseVAST: function(vastEl) {
            var adEls = XML2.getChildren(vastEl, 'Ad');
            for (var i = 0, f = adEls.length; i < f; ++i) {
                this.parseAd(adEls[i]);
            }
        },

        parseAd: function(adEl) {
            var i, f;

            var wrapperEls = XML2.getChildren(adEl, 'Wrapper');
            for (i = 0, f = wrapperEls.length; i < f; ++i) {
                this.parseWrapper(wrapperEls[i]);
            }

            var inLineEls = XML2.getChildren(adEl, 'InLine');
            for (i = 0, f = inLineEls.length; i < f; ++i) {
                this.parseInLine(inLineEls[i]);
            }
        },

        parseWrapper: function(wrapperEl) {
            this.parseErrorAndImpression(wrapperEl);

            var i, f, creativeEl, i2, f2, els, el;

            var creativeEls = XML2.getChildren(wrapperEl, 'Creative');
            for (i = 0, f = creativeEls.length; i < f; ++i) {
                creativeEl = creativeEls[i];

                els = toArray( XML2.getChildren(creativeEl, 'Linear') );
                for (i2 = 0, f2 = els.length; i2 < f2; ++i2) {
                    el = els[i2];
                    this.parseTracking(el, this._data.globalTracking.linears);
                    this.parseVideoClicks(el, this._data.globalVideoClicks);
                }

                els = toArray( XML2.getChildren(creativeEl, 'NonLinearAds') );
                for (i2 = 0, f2 = els.length; i2 < f2; ++i2) {
                    el = els[i2];
                    this.parseTracking(el, this._data.globalTracking.nonLinears);
                }

                els = toArray( XML2.getChildren(creativeEl, 'CompanionAds') );
                for (i2 = 0, f2 = els.length; i2 < f2; ++i2) {
                    el = els[i2];
                    this.parseTracking(el, this._data.globalTracking.companions);
                }
            }

            var xmlVastDocUrl = XML2.getTrimmedText(wrapperEl, 'VASTAdTagURI');
            //xmlVastDocUrl += '&rnd=' + ( ~~(Math.random() * Math.pow(32, 6)) ).toString(32);

            this.getDocument(xmlVastDocUrl, true);
        },

        parseErrorAndImpression: function(el) { // el can be WrapperEl or InLine

            // NEW
            var subBag, adEl, adId = '*';
            var isWrapper = ( el.nodeName.toLowerCase().indexOf('wrapper') !== -1 );
            if (!isWrapper) {
                adEl = getAncestor(el, 'ad');
                if (adEl) {
                    adId = adEl.getAttribute('id');
                }
            }
            // NEW

            /*var subBag, adId, adTitle, adEl = getAncestor(el, 'ad');
            if (adEl) {
                adId    = adEl.getAttribute('id');
                adTitle = XML2.getTrimmedText(el, 'AdTitle');
            }
            else {
                adId = '*'; // wrapper?
            }*/

            subBag = this._data.ads[adId];
            if (!subBag) {
                subBag = {error:[], impression:[]};
                this._data.ads[adId] = subBag;
            }

            if (adEl) {
                subBag.system      = XML2.getTrimmedText(el, 'AdSystem');
                subBag.title       = XML2.getTrimmedText(el, 'AdTitle');
                subBag.description = XML2.getTrimmedText(el, 'Description');
                subBag.advertiser  = XML2.getTrimmedText(el, 'Advertiser');
            }
            /*else {
                adId = '*'; // wrapper?
            }*/

            // error
            pushIfLacking(subBag.error, XML2.getTrimmedText(el, 'Error') );

            // impression
            var impressionEls = XML2.getChildren(el, 'Impression');
            for (var i = 0, f = impressionEls.length; i < f; ++i) {
                pushIfLacking(subBag.impression, XML2.trimmedText( impressionEls[i] ) );
            }
        },

        parseTracking: function(parentEl, tBag) {
            var i, f, el, k, v;

            var trackingEls = XML2.getChildren(parentEl, 'Tracking');
            for (i = 0, f = trackingEls.length; i < f; ++i) {
                el = trackingEls[i];
                k = el.getAttribute('event');
                v = XML2.trimmedText(el);

                if (k in tBag) { pushIfLacking(tBag[k], v); }
                else {           tBag[k] = [v];             }
            }
        },

        parseVideoClicks: function(parentEl, vcBag) {
            /*jshint boss:true */

            var videoClicksEl = XML2.getChildren(parentEl, 'VideoClicks')[0];
            if (!videoClicksEl) { return; }

            var nd = videoClicksEl.firstChild;
            var k, v;
            do {
                if (nd.nodeType !== 1) { continue; }
                k = nd.nodeName.toLowerCase();
                k = k.substring( nd.nodeName.indexOf('click') + 6 );
                v = XML2.trim( XML2.trimmedText(nd) );

                if (k in vcBag) { pushIfLacking(vcBag[k], v); }
                else {            vcBag[k] = [v];             }
            } while (nd = nd.nextSibling);
        },

        parseInLine: function(inLineEl) {
            this.parseErrorAndImpression(inLineEl);

           /* console.log('AdSystem',    XML2.getText(inLineEl, 'AdSystem') );
            console.log('AdTitle',     XML2.getText(inLineEl, 'AdTitle') );
            console.log('Description', XML2.getText(inLineEl, 'Description') );
            console.log('Advertiser',  XML2.getText(inLineEl, 'Advertiser') );*/

            //this._data.titles.push( XML2.getText(inLineEl, 'AdTitle') );

            var i, f, creativeEl, i2, f2, els;
            var creativeEls = XML2.getChildren(inLineEl, 'Creative');

            for (i = 0, f = creativeEls.length; i < f; ++i) {
                creativeEl = creativeEls[i];

                els = XML2.getChildren(creativeEl, 'Linear');
                for (i2 = 0, f2 = els.length; i2 < f2; ++i2) {
                    this.parseLinear(els[i2], creativeEl);
                }

                els = XML2.getChildren(creativeEl, 'NonLinearAds');
                for (i2 = 0, f2 = els.length; i2 < f2; ++i2) {
                    this.parseNonLinearAds(els[i2], creativeEl);
                }

                els = XML2.getChildren(creativeEl, 'CompanionAds');
                for (i2 = 0, f2 = els.length; i2 < f2; ++i2) {
                    this.parseCompanionAds(els[i2], creativeEl);
                }
            }
        },

        parseIds: function(creativeEl) {
            var creativeId = creativeEl.getAttribute('id');
            var adEl       = getAncestor(creativeEl, 'ad');
            var adId       = adEl.getAttribute('id');
            var adSequence = parseInt( adEl.getAttribute('sequence'), 10);
            return {
                adId:       adId,
                adSequence: adSequence,
                creativeId: creativeId
            };
        },

        parseLinear: function(linearEl, creativeEl) {
            var i, f, k, rollKey;

            var ids = this.parseIds(creativeEl);

            var seq = linearEl.getAttribute('sequence') || ids.adSequence;

            switch (seq) {
                case 3:
                    rollKey = 'post';
                    break;

                case 2:
                    rollKey = 'mid';
                    break;

                //case 1:
                default:
                    rollKey = 'pre';
            }

            // console.log(seq, rollKey);

            var bag = {
                adId:         ids.adId,
                creativeId:   ids.creativeId,
                stage:        rollKey,
                duration:     undefined,
                tracking:     clone( this._data.globalTracking.linears ),
                videoClicks:  clone( this._data.globalVideoClicks ),
                adParameters: {}
            };

            // duration
            bag.duration = XML2.getTrimmedText(linearEl, 'Duration');
            bag.duration = XML2.parseTime( bag.duration );

            // tracking
            this.parseTracking(linearEl, bag.tracking);

            // ad parameters
            var adParameters = XML2.getTrimmedText(linearEl, 'AdParameters');
            adParameters = adParameters.split(';');
            for (i = 0, f = adParameters.length; i < f; ++i) {
                k = adParameters[i].split('=');
                if (k[0] === '') { continue; }
                bag.adParameters[ k[0] ] = k[1];
            }

            // casts
            if ('allowCloseButton'   in bag.adParameters) { bag.adParameters.allowCloseButton   = Boolean(bag.adParameters.allowCloseButton);   }
            if ('timeForCloseButton' in bag.adParameters) { bag.adParameters.timeForCloseButton = Number( bag.adParameters.timeForCloseButton); }

            // video clicks
            this.parseVideoClicks(linearEl, bag.videoClicks);

            // media file elements
            var mediaFilesEl = XML2.getChildren(linearEl, 'MediaFiles');
            mediaFilesEl = mediaFilesEl[0];
            this.emit('MediaFiles', mediaFilesEl, bag);

        },

        parseNonLinearAds: function(nonLinearAdsEl, creativeEl) {
            var ids = this.parseIds(creativeEl);

            var bag = {
                adId:        ids.adId,
                creativeId:  ids.creativeId,
                tracking:    clone( this._data.globalTracking.nonLinears )
            };

            // tracking
            this.parseTracking(nonLinearAdsEl, bag.tracking);

            this.emit('NonLinearAds', nonLinearAdsEl, bag);
        },

        parseCompanionAds: function(companionAdsEl, creativeEl) {
            var ids = this.parseIds(creativeEl);

            var bag = {
                adId:       ids.adId,
                creativeId: ids.creativeId,
                tracking:   clone( this._data.globalTracking.companions ),
            };

            // tracking
            this.parseTracking(companionAdsEl, bag.tracking);

            this.emit('CompanionAds', companionAdsEl, bag);
        },

        getFailed: function(url) {
            this.emit('error', {code:301, message:'error requesting ' + url});

            if (this._sourceFilesRemaining === 1) {
                if (!this._data) { this.reset(); }
                this.emit('done', this._data);
            }
        },



        on: function(eventType, cb) { // START OF EVENT EMITTER API
            var bag = this._listeners[eventType];
            if (!bag) {
                bag = [];
                this._listeners[eventType] = bag;
            }

            if (this._maxListeners !== 0) {
                var l = bag.length + 1;
                if (bag.length > this._maxListeners) {
                    window.console.log( ['WARN: event ', eventType, ' has ', l,' listeners!'].join('') );
                }
            }

            bag.unshift(cb);

            this.emit('newListener', (typeof cb === 'function') ? cb : cb[0]);

            return this;
        },

        addListener: function(eventType, cb) { // alias to on
            return this.on(eventType, cb);
        },

        once: function(eventType, cb) {
            return this._on(eventType, [cb]);
        },

        removeListener: function(eventType, cbToRemove) {
            var bag = this._listeners[eventType];
            if (!bag) { return this; }

            var i, cb, isFn;
            for (i = bag.length - 1; i >= 0; --i) {
                cb = bag[i];

                isFn = (typeof cb !== 'function');
                if (!isFn) { cb = cb[0]; }

                if (!cbToRemove || cb === cbToRemove) {
                    bag.splice(i, 1);
                }
            }

            return this;
        },

        removeAllListeners: function(eventType) {
            return this.removeListener(eventType);
        },

        setMaxListeners: function(n) { // 0 === unlimited
            this._maxListeners = n;

            return this;
        },

        listeners: function(eventType) {
            return this._listeners[eventType];
        },

        emit: function(/*eventType, [[arg1], arg2]...*/) {
            var argsL = arguments.length;
            var args = new Array(argsL); // optimizable arguments-to-array
            for(var i = 0; i < argsL; ++i) {
                args[i] = arguments[i];
            }

            var eventType = args.shift();

            var bag = this._listeners[eventType];
            if (!bag || bag.length === 0) {
                return false;
            }

            var cb, removeThis;
            for (i = bag.length - 1; i >= 0; --i) {
                cb = bag[i];

                removeThis = (typeof cb !== 'function');
                if (removeThis) { cb = cb[0]; }

                cb.apply(null, args);

                if (removeThis) {
                    bag.splice(i, 1);
                }
            }

            return true;
        },

        listenerCount: function(eventType) { // yeah I know, node has a class method...
            var bag = this._listeners[eventType];
            return (bag ? bag.length : 0);
        } // END OF EVENT EMITTER API

    };

    //SAPO.namespace('Project.Video.VAST');
    SAPO.namespace('Project.Video.VAST.parsers');
    SAPO.namespace('Project.Video.VAST.handlers');
    SAPO.namespace('Project.Video.VAST.VPAID');

    SAPO.Project.Video.VAST.VASTParser = VASTParser;

})();
